export interface ISchoolShortData {
  id: number;
  name: string;
  active: boolean;
  updated_at: string;
  memberships_count: number;
  school_type: ESchoolType;
}

/**
 * Форматы учёбы в школе
 */
export enum ESchoolFormat {
  Online = 'online',
  Offline = 'offline',
  Hybrid = 'hybrid',
}

/**
 * Тип подсекции для школы
 */
export enum ESchoolSubsection {
  Faq = 'faq',
  Program = 'program',
  Abilities = 'abilities',
  Speakers = 'speakers',
}

/**
 * Типы иконок для бейджей школы
 */
export enum ESchoolBadgeIcons {
  Star = 'star',
  Enter = 'enter',
  Command = 'command',
  Code = 'code',
  Pipeline = 'pipeline',
  Box = 'box',
  Pencil = 'pencil',
  Checklist = 'checklist',
  Interface = 'interface',
  Chart = 'chart',
  Briefcase = 'briefcase',
}

/**
 * Тип школы
 */
export enum ESchoolType {
  Public = 'public_school',
  Corporate = 'corporate_school',
}

/**
 * Виды форм обучения
 */
export enum EStudyForm {
  FullTimeStudy = 'full_time_study',
  PartTimeStudy = 'part_time_study',
  RemoteStudy = 'remote_study',
  NotStudying = 'not_studying',
}

/**
 * Виды уровня образования
 */
export enum EEducationLevel {
  BasicGeneralEducation = 'basic_general_education',
  SecondaryGeneralEducation = 'secondary_general_education',
  SecondaryProfessionalEducation = 'secondary_professional_education',
  BachelorEducation = 'bachelor_education',
  SpecialistEducation = 'specialist_education',
  MasterEducation = 'master_education',
  DoctoralEducation = 'doctoral_education',
  NotEducating = 'not_educating',
}

/**
 * Виды года обучения
 */
export enum EStudyYear {
  FirstCourse = 'first_course',
  SecondCourse = 'second_course',
  ThirdCourse = 'third_course',
  FourthCourse = 'fourth_course',
  FifthCourse = 'fifth_course',
  SixthCourse = 'sixth_course',
  Graduate2026 = 'graduate_2026',
  Graduate2025AndEarlier = 'graduate_2025_and_earlier',
}
